module.exports = __webpack_public_path__ + "img/license.057a4448.png";